import { useEffect, useState } from 'react';
import { Loader2, Package } from 'lucide-react';
import { authAPI } from '../api';
import { InventoryContent } from './Dashboard';

const MANAGEMENT_ROLES = ['Management', 'Owner', 'Co-Owner', 'Admin'];

const Inventory = () => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authAPI.getUserProfile()
      .then(r => setUser(r.data))
      .catch(() => { window.location.href = '/'; })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-[var(--gty-accent,#a855f7)]" />
      </div>
    );
  }
  if (!user) return null;

  const isManagement     = user?.role_names?.some(r => MANAGEMENT_ROLES.includes(r));
  const isSeniorOperator = user?.role_names?.includes('Senior Operator');
  const canWrite         = isManagement || isSeniorOperator;

  return (
    <div className="min-h-screen bg-[var(--gty-bg, #0a0a0a)] text-white" data-testid="inventory-page-standalone">
      {/* Page chrome */}
      <div className="border-b border-[var(--gty-border)] bg-black/40 backdrop-blur">
        <div className="max-w-[1600px] mx-auto px-6 py-5 flex items-center gap-3">
          <div className="w-9 h-9 border border-[var(--gty-accent,#a855f7)] flex items-center justify-center">
            <Package className="w-4 h-4 text-[var(--gty-accent,#a855f7)]" />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-[var(--gty-text-faint)]">
              GTY · Stock Management
            </span>
            <h1 className="text-xl font-black uppercase tracking-wider">Inventory</h1>
          </div>
          <div className="ml-auto flex items-center gap-3">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="text-[10px] font-mono uppercase tracking-widest text-[var(--gty-text-faint)]">Logged in as</span>
              <span className="text-sm font-bold">{user.display_name || user.username}</span>
            </div>
            {user.avatar_url && (
              <img
                src={user.avatar_url}
                alt=""
                className="w-9 h-9 border border-[var(--gty-border)] object-cover"
              />
            )}
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="max-w-[1600px] mx-auto px-6 py-8">
        <InventoryContent user={user} isManagement={isManagement} canWrite={canWrite} />
      </div>
    </div>
  );
};

export default Inventory;
